define(function(require, exports, module) {
    'use strict';

    const $ = require('j');
    const i18n = require('i18n');
    const _ = require('underscore');
    const config = require('config');
    const server = require('server');
    const device = require('util/device.util');

    module.exports = {

        getURLsRequest: function(options) {
            var request = {
                ID: 35844,
                description: 'Get URLs Request',
                responses: [31032, 31033],
                casinoName: config.get('casinoName'),
                clientSkinName: config.get('clientSkin'),
                clientPlatform: device.clientPlatform,
                clientType: config.get('clientType'),
                urlTypeList: []
            };

            return server.send(_.extend(request, options));
        },

        sendBatchRequest: function(requests, userId) {
            if (requests.length === 0) {
                return $.Deferred().resolve();
            }

            var description = requests.map(function(req) {
                return req.description;
            }).join(', ');

            var batchRequest = {
                ID: 35508,
                responses: [35516, 35517],
                description: 'Batch: ' + description,
                errorLevel: 1,
                authParameters: {
                    casinoName: config.get('casinoName'),
                    playerName: userId
                },
                requests: requests
            };

            return server.send(batchRequest);
        },

        getErrorMessage: function(error, { tkPrefix, defaultMessage } = {}) {
            const systemError = i18n.tExt('playtech.mobile.system.systemError', 'System error');

            if (error && typeof error === 'object' && !Array.isArray(error)) {
                const {
                    actions,
                    errorCode,
                    userErrors,
                    errorMessage,
                    playerMessage,
                    customError
                } = error.data || error.response?.data || {};

                const userError = userErrors?.[0]?.message || userErrors?.UserError?.[0]?.message;
                const actionMessage = actions?.PlayerActionShowMessage?.[0]?.message
                    || actions?.showMessageNotificationInfo?.message;
                const spareMessage = playerMessage
                    || errorMessage
                    || customError && i18n.tExt(customError, customError)
                    || defaultMessage;

                return userError
                    || actionMessage
                    || i18n.tExt(`${tkPrefix}${errorCode}`, spareMessage ?? systemError);
            }

            return systemError;
        }
    };
});
